<template>
  <NoteWithIcon color="red" style="min-width: 400px">
    <template #icon>
      <IconEmbedded name="info-simple_4" :size="25" />
    </template>
    <template #text>
      <div>
        <h3 class="global-h3" style="margin-bottom: 4px">{{ headingText }}</h3>
        <div>
          <div style="margin-bottom: 5px">
            <div style="margin-bottom: 5px">The profile is no longer publicly visible.</div>
          </div>
        </div>
      </div>
    </template>
  </NoteWithIcon>
</template>

<script setup lang="ts">
import { computed } from "vue";
import NoteWithIcon from "@components/NoteWithIcon.vue";
import IconEmbedded from "@components/ui/IconEmbedded.vue";
import { useUserProfileStore } from "@stores/userProfileStore";

const userProfileStore = useUserProfileStore();

const headingText = computed(() => {
  const profile = userProfileStore.getViewingUserProfile;
  if (profile?.removedProfile?.removedOn) {
    const date = new Date(profile.removedProfile.removedOn);
    const formattedDate = date.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
    return `This account was removed on ${formattedDate}`;
  }
  return "This account is disabled";
});
</script>
